import TeethChartInput from '@/components/includes/TeethChart'

export default function TeethChartField ({ value, onChange }) {
  function handleChange (chart) {
    if (!chart || Object.keys(chart).length === 0) {
      onChange(null)
    } else {
      onChange(chart)
    }
  }
  return <TeethChartInput value={value ?? {}} onChange={handleChange} />
}
